import { IDataModal } from 'screens/estimate';
import ModalRedirectToPageWizard from '../modalRedirectToPageWizard';
import { API_WIZARD_SELL, TILDA_PATHS } from 'lib/constants';

export type TModeSellModal = 'sell' | 'tarde-in';

interface IModalTradeInProps {
  isOpen: boolean;
  data: IDataModal | null;
  mode: 'sell' | 'tarde-in';
  onDismiss: (value: boolean) => void;
}

const TEXT_SELL =
  'Перейдите к оформлению заявки и мы поможем продать вашу квартиру на выгодных условиях.';

const TEXT_TRADEIN =
  'Trade-in услуга по обмену вашей квартиры на новую. Перейдите к оформлению заявки и мы поможем подобрать вам новое жилье.';

const TITLE_SELL = 'Помощь в продаже';
const TITLE_TRADEIN = 'Trade-in';

const ModalRedirectToPageWizardSell = ({ isOpen, data, mode, onDismiss }: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.reitInvest.tradeIn, "_blank");
  };

  return (
    <ModalRedirectToPageWizard
      title={mode === 'sell' ? TITLE_SELL : TITLE_TRADEIN}
      text={mode === 'sell' ? TEXT_SELL : TEXT_TRADEIN}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
    />
  );
};
export default ModalRedirectToPageWizardSell;
